import React from "react";
import PropTypes from "prop-types";
import { Badge } from "./ActionBadge.styles";

export const ActionBadge = ({ type, children }) => {
  const displayValue = children || type;

  return <Badge $type={type}>{displayValue}</Badge>;
};

ActionBadge.propTypes = {
  type: PropTypes.string.isRequired,
  children: PropTypes.node,
};
